import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApiUrls } from '../../../config/api-urls/api-urls';
import { MainService } from '../../../provider/main.service';
declare var $: any;
@Component({
  standalone: false,
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.css']
})
export class ChatComponent implements OnInit {

  searchForm: FormGroup | any;
  // whichmodal: string = 'enable';
  itemPerPage = 10;
  currentPage = 1;
  total: any;
  helplineId: any
  faqList: any = [];
  faqId: any;
  message: any;
  chatHistoryData: any = [];
  senderId: string | any;
  isSearch: boolean = false;
  userImage: any = "https://ptetutorials.com/images/user-profile.png";
  therapistList: any = [];
  userId: any;
  chatHistoryDataa: any = [];
  staffListData: any;
  tabView: any = 'THERAPIST';
  chatHistorySubs: Subscription | any;

  constructor(private router: Router,
    public mainService: MainService) { }
  ngOnInit() {
    this.searchFormValidation();
    // this.chatHistory(this.userId);
    this.senderId = localStorage.getItem('adminId')
    this.staffListApii();
  }

  searchFormValidation() {
    this.searchForm = new FormGroup({
      search: new FormControl('')
    });
  }

  searchFormSubmit() {
    if (this.searchForm.value.search) {
      // this.getFaqList()
    }
  }
  searchFormReset() {
    if (this.searchForm.value.search) {
      this.searchForm.reset();
      // this.getFaqList()
    }
  }

  pagination(event: any) {
    this.currentPage = event;
    // this.getFaqList()
  }

  deleteFaqModal(id: any) {
    this.faqId = id
    $('#delete').modal('show')
  }

  sendMessage() {
    const data = {
      "senderId": localStorage.getItem('adminId'),
      "receiverId": this.userId,
      "message": this.message
    }
    this.mainService.postApi(ApiUrls.sendMessage, data, 1).subscribe((res: any) => {
      if (res.responseCode == 200) {
        this.message = '';
        this.chatHistory(this.userId)
      }
    })
  }

  chatHistory(id: any) {
    this.userId = id;
    const data = {
      // adminId: localStorage.getItem('adminId'),
      "receiverId": this.userId,
    }
    this.chatHistorySubs = this.mainService.postApi(ApiUrls.chatHistory, data, 1).subscribe((res: any) => {
      if (res.responseCode == 200) {
        this.chatHistoryData = res.result ? res.result : [];
      }
      else {
        this.chatHistoryData = res.result ? res.result : [];
      }
    })
  }
  viewTab(tab: any) {
    this.tabView = tab;
    this.staffListApii();
    this.chatHistoryData = [];
  }

  // staff list api 

  staffListApii() {
    let userType;
    if (this.tabView == 'THERAPIST') {
      userType = 'THERAPIST';
    }
    else if (this.tabView == 'SUBADMIN') {
      userType = 'SUBADMIN';
    }
    else {
      userType = 'USER';
    }
    this.mainService.showSpinner()
    this.mainService.getApi(ApiUrls.userList + `?search=${this.searchForm.value.search}&userType=${userType}`, 1).subscribe((res) => {
      if (res.responseCode == 200) {
        this.therapistList = res.result;

        this.mainService.hideSpinner();
      }
      else {
        this.mainService.hideSpinner();
        this.mainService.errorToast(res.responseMessage)
      }
    }, err => {
      this.mainService.hideSpinner();
      this.mainService.errorToast(err.responseMessage)
    })
  }

  onImageError(event: any) {
    event.target.src = 'https://res.cloudinary.com/smsit/image/upload/v1597335652/fmcvdi2g6ogd5vwzvzfa.jpg';
  }
}
